import React, { Fragment, useEffect, useState } from "react";
import Option from "./components/Option";

const Question = ({
  mainOptionSlug,
  question,
  onQuestionAnswered,
  selection,
}) => {
  const [showAdditionalNotes, setShowAdditionalNotes] = useState(false);
  const [additionalNotes, setAdditionalNotes] = useState("");

  useEffect(() => {
    console.log("question selection", selection, question);

    //If the question has been answered with an option that needs additional notes, show addtionalNotes.
    let questionInSelection =
      selection[mainOptionSlug] &&
      selection[mainOptionSlug].additionalQuestions &&
      selection[mainOptionSlug].additionalQuestions[question.slug];

    if (!questionInSelection) {
      return;
    }

    let questionAnswer = question.options.find((option) => {
      return option.answer === questionInSelection.answer;
    });

    if (!questionAnswer) {
      return;
    }

    if (questionAnswer.additionalNotes) {
      setShowAdditionalNotes(true);
    } else {
      setShowAdditionalNotes(false);
      setAdditionalNotes("");
    }

    //Set additional notes initial value
    if (questionInSelection && questionInSelection.additionalNotes) {
      setAdditionalNotes(questionInSelection.additionalNotes);
    }
  }, [selection]);

  // const isSelected = (answer) => {
  //   return (
  //     selection[mainOptionSlug] &&
  //     selection[mainOptionSlug].additionalQuestions &&
  //     selection[mainOptionSlug].additionalQuestions[question.slug] &&
  //     selection[mainOptionSlug].additionalQuestions[question.slug].answer ===
  //       answer
  //   );
  // };

  return (
    <div className="flex flex-col items-stretch md:items-center gap-2 font-bold">
      {/* Q/A */}
      <div className="flex items-center gap-2 bg-[#FFFFFF] py-2 px-4 border-2 rounded-xl shadow-sm">
        {/* QUESTION */}
        <div>
          <h4>{question.question}</h4>
        </div>
        {/* ANSWERS */}
        <div className="flex gap-2">
          {/* ANSWER */}
          {question.options.map((option) => {
            let answer = option.answer;
            let isSelected =
              selection[mainOptionSlug] &&
              selection[mainOptionSlug].additionalQuestions &&
              selection[mainOptionSlug].additionalQuestions[question.slug] &&
              selection[mainOptionSlug].additionalQuestions[question.slug]
                .answer === answer;

            return (
              <Option
                isSelected={isSelected}
                onClick={() => {
                  //   alert("hello");
                  onQuestionAnswered &&
                    onQuestionAnswered(
                      mainOptionSlug,
                      question.slug,
                      option.answer,
                      ""
                    );
                }}
                option={option}
              />
            );
          })}
        </div>
      </div>
      {/* ADDITIONAL NOTES */}
      <div className="w-full">
        {showAdditionalNotes && (
          <Fragment>
            <p className="lowercase text-center w-full mb-2 mirum-color-blue text-black">
              please provide further details below:
            </p>
            <textarea
              placeholder="e.g. no nuts, vegan, pescatarian, halal etc."
              className="mirum-text-field w-full mb-[100px]"
              onChange={(e) => {
                setAdditionalNotes(e.target.value);
                onQuestionAnswered &&
                  onQuestionAnswered(
                    mainOptionSlug,
                    question.slug,
                    selection[mainOptionSlug].additionalQuestions[question.slug]
                      .answer,
                    e.target.value
                  );
              }}
              value={additionalNotes}
              required={true}
            />
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default Question;
